export class Api extends Endorphine.Api
{

	constructor(id, params = {}, result = {}, options = {})
	{
		super(id)
	}

}
